import angular from 'angular';
import Logger from '../../../shared/logger';

export const CandidatesContactService = (Restangular) => {
    const contactCandidatesWithHiddenDetailsByEmail = function ({
        contactType,
        positionId,
        recipientsData,
        message,
        emailData,
    }) {
        return Restangular
            .all('candidate/contact/email/hidden')
            .post({
                contactType,
                positionId,
                recipientsData,
                message,
                emailData,
            })
            .catch(error => Logger.error(error));
    };

    const addCandidateContactCampaignSentMessage = function ({
        contactType,
        sentMessage,
        positionId,
        talentId,
    }) {
        return Restangular
            .all('candidate/contact/sentMessage/add')
            .post({
                contactType,
                sentMessage,
                positionId,
                talentId,
            })
            .catch(error => Logger.error(error));
    };

    return {
        addCandidateContactCampaignSentMessage,
        contactCandidatesWithHiddenDetailsByEmail,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CandidatesContactService', CandidatesContactService);
